import { ChangeDetectorRef, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CallEpisodePrescriptionService } from 'src/app/shared/services/API/orchestrator-patient/call-episode-prescription.service';
import { MedicinePresentationTypeService } from 'src/app/shared/services/API/pharmacy/medicine-presentation-type.service';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { LocationModel } from 'src/app/shared/services/models/pharmacy/location.model';
import { EpisodeStruct } from 'src/app/shared/services/structs/medical-record/episode.struct';
import { LiberatePrescriptionRequest } from 'src/app/shared/services/requests/orchestrator-patient/liberate-prescription.request';
import { PrescriptionStatusEnum } from 'src/app/shared/enum/prescription-status.enum';
import { PrescriptionNonDispensationRequest } from 'src/app/shared/services/requests/medical-record/prescription-non-dispensation.request';
import { ReportModalComponent } from 'src/app/shared/components/report-modal/report-modal.component';
import { LiberateSolutionPrescriptionRequest } from 'src/app/shared/services/requests/orchestrator-patient/liberate-solution-prescription.request';
import { GetMedicineDataService } from 'src/app/shared/services/API/pharmacy/get-medicine-data.service';
import { AlertModalComponent } from 'src/app/shared/components/alert-modal/alert-modal.component';
import { AdditionalItemForPrescriptionReleaseFormStruct } from 'src/app/shared/services/structs/pharmacy/additional-item-for-prescription-release-form.struct';
import { AdditionalMedicineForPrescriptionReleaseFormStruct } from 'src/app/shared/services/structs/pharmacy/additional-medicine-for-prescription-release-form.struct';
import { AdditionalItemModalComponent } from 'src/app/shared/components/additional-item-modal/additional-item-modal.component';
import { AdditionalElementsToKitSearchRequest } from 'src/app/shared/services/requests/pharmacy/additional-elements-to-kit-search.request';
import { KitService } from 'src/app/shared/services/API/pharmacy/kit.service';
import { PrescriptionSolutionStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution.struct';
import { PrescriptionSolutionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-medicine.struct';
import { ReleasePrescriptionSolutionModalComponent } from 'src/app/shared/components/release-prescription-solution-modal/release-prescription-solution-modal.component';
import { PrescriptionSolutionNonDispensationAllModalComponent } from 'src/app/shared/components/prescription-solution-non-dispensation-all-modal/prescription-solution-non-dispensation-all-modal.component';

@Component({
    selector: 'app-prescription-solution-modal',
    templateUrl: './prescription-solution-modal.component.html',
    styleUrls: ['./prescription-solution-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescriptionSolutionModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescriptionSolutionModalComponent>,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    public callEpisodePrescriptionService: CallEpisodePrescriptionService,
    public medicinePresentationTypeService: MedicinePresentationTypeService,
    public kitService: KitService,
    private cdr: ChangeDetectorRef,
    public getMedicineDataService: GetMedicineDataService,
  ) { this.matDialogRef.disableClose = true; }

  public model: FormGroup;
  public episode: EpisodeStruct = new EpisodeStruct();
  public solution: PrescriptionSolutionStruct;

  public listLiberatePrescription: LiberatePrescriptionRequest[] = [];
  public listPrescriptionNonDispensationRequest: PrescriptionNonDispensationRequest[] = [];
  public listLocation: LocationModel[];
  public listSolution: PrescriptionSolutionStruct[];
  public listAdditionalItemsForRequest: AdditionalItemForPrescriptionReleaseFormStruct[] = [];
  public listAdditionalMedicinesForRequest: AdditionalMedicineForPrescriptionReleaseFormStruct[] = [];

  public isLoading: boolean = false;
  public validated: boolean = false;
  public nonDispenseAll: boolean = false;
  public isInBulk: boolean = false;
  public isObservation: boolean = false;
  public idSector: number;

  public statusLiberatePrescriptionEnum: PrescriptionStatusEnum = PrescriptionStatusEnum.Liberado.valueOf();
  public statusNotDispensationPrescriptionEnum: PrescriptionStatusEnum = PrescriptionStatusEnum.NaoDispensado.valueOf();
  public statusOpenPrescriptionEnum: PrescriptionStatusEnum = PrescriptionStatusEnum.EmAberto.valueOf();

  public listIdKit: number[] = [];
  public indexSolution: number;
  public progressDispensation: number = 0;

  ngOnInit(): void {
    this.listLocation = this.data.listLocation;

    if (this.data.isObservation) {
      this.isObservation = true;
      this.idSector = this.data.idSector;
    }

    if (this.data.episode) {
      this.episode = this.data.episode;
    }

    if (this.data.solution) {
      this.mapPrescription(this.data.solution);
    }
    else if (this.data.listSolution) {
      this.isInBulk = true;
      this.indexSolution = 0;
      this.listSolution = this.data.listSolution;
      this.mapPrescription(this.listSolution[this.indexSolution]);
    }
  }

  mapPrescription(solution: PrescriptionSolutionStruct) {
    this.solution = solution;

    this.model = this.formBuilder.group({
      idLocation: [, [Validators.required]],
    });

    if (this.isObservation) {
      const location = this.listLocation.find(x => x.idSector === this.idSector);
      this.model.get('idLocation').setValue(location?.idLocation);
      this.model.get('idLocation').disable();
    }

    if (solution?.listSelectedIdKit?.length > 0)
      this.getAdditionalElementsForDispenssing(solution?.listSelectedIdKit);
  }

  close() {
    this.matDialogRef.close({ checkMedicine: false });
  }

  submit() {
    this.model.get('idLocation').markAsTouched();
 
    if (this.isLoading || this.model.invalid)
      return;

    if (!this.validateAdditionalItemsToSubmit() || !this.validateAdditionalMedicinesToSubmit()) {
      this.alertService.show('Erro', 'Todos os itens adicionais devem ter item, estoque e quantidade preenchidos.', AlertType.error);
      return;
    }

    this.isLoading = true;

    let liberateSolutionPrescriptionRequest: LiberateSolutionPrescriptionRequest = new LiberateSolutionPrescriptionRequest();
    liberateSolutionPrescriptionRequest.listLiberatePrescription.push(...this.listLiberatePrescription);
    liberateSolutionPrescriptionRequest.listPrescriptionNonDispensationRequest.push(...this.listPrescriptionNonDispensationRequest);

    if (this.listAdditionalItemsForRequest && this.listAdditionalItemsForRequest.length > 0) {
      liberateSolutionPrescriptionRequest.listAdditionalItemForPrescriptionRelease = this.listAdditionalItemsForRequest.map(x => x.additionalItemForPrescriptionRelease);
    }
    if (this.listAdditionalMedicinesForRequest && this.listAdditionalMedicinesForRequest.length > 0) {
      liberateSolutionPrescriptionRequest.listAdditionalMedicineForPrescriptionRelease = this.listAdditionalMedicinesForRequest.map(x => x.additionalMedicineForPrescriptionRelease);
    }

    this.callEpisodePrescriptionService.liberatePrescriptionSolution(liberateSolutionPrescriptionRequest).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.isLoading = false;
        this.alertService.show('Sucesso', "Prescrições liberadas com sucesso!", AlertType.success);

        if (!this.isInBulk || (this.isInBulk && this.listSolution.length == this.indexSolution + 1))
          this.matDialogRef.close({ checkMedicine: true });
        else {
          this.indexSolution += 1;
          this.progressDispensation = (this.indexSolution * 100) / this.listSolution.length;
          this.mapPrescription(this.listSolution[this.indexSolution]);
        }

        if (response.isActive == true) {
          this.dialog.open(ReportModalComponent, {
            data: {
              reportName: response.reportName,
              reportPdf64: response.reportPdf64,
            },
          });
        }
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  validateAdditionalItemsToSubmit(): boolean {
    if (!this.listAdditionalItemsForRequest?.length)
      return true;

    return this.listAdditionalItemsForRequest?.every(item => {
      var isValid = item.additionalItemForPrescriptionRelease?.idItem &&
        item.additionalItemForPrescriptionRelease?.idStorage &&
        item.additionalItemForPrescriptionRelease?.numberOfItens;

      return isValid;
    });
  }

  validateAdditionalMedicinesToSubmit(): boolean {
    if (!this.listAdditionalMedicinesForRequest?.length)
      return true;

    return this.listAdditionalMedicinesForRequest.every(medicine => {
      var isValid = medicine.additionalMedicineForPrescriptionRelease?.idMedicine &&
        medicine.additionalMedicineForPrescriptionRelease?.idStorage &&
        medicine.additionalMedicineForPrescriptionRelease?.numberOfItens;

      return isValid;
    });
  }

  getAdditionalElementsForDispenssing(listIdKit: number[] = []) {
      this.isLoading = true;
      let body = new AdditionalElementsToKitSearchRequest();
      body.listIdKit = listIdKit;

      if (this.isObservation) {
        body.idSector = this.idSector;
      }

      if (!listIdKit || listIdKit.length === 0 || (listIdKit.length === 1 && listIdKit.some(x => x === 0 || x === null)))
        return;
      
      this.kitService.GetAdditionalElementsByIdKit(body).subscribe({
        next: (response) => {
          if (response.isError) {
            this.alertService.show('Erro', response.errorDescription, AlertType.error);
            this.isLoading = false;
            return;
          }
  
          if (response.listAdditionalItemForPrescriptionReleaseForm && response.listAdditionalItemForPrescriptionReleaseForm.length > 0)
            this.listAdditionalItemsForRequest = [...response.listAdditionalItemForPrescriptionReleaseForm];
  
          if (response.listAdditionalMedicinesForPrescriptionReleaseForm && response.listAdditionalMedicinesForPrescriptionReleaseForm.length > 0)
            this.listAdditionalMedicinesForRequest = [...response.listAdditionalMedicinesForPrescriptionReleaseForm];
  
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.alertService.show('Erro inesperado', error, AlertType.error);
        }
      });
  }

  clickCancel() {
    if (this.isLoading)
      return;

    if (this.isInBulk) {
      const dialogRef = this.dialog.open(AlertModalComponent, {
        data: {
          isTwoButtonsModal: true,
          title: 'Atenção!',
          description: `Ainda existem ${this.listSolution.length - this.indexSolution} solução(ões) que não foi/foram liberado(s). 
                        \n Deseja cancelar o processo de dispensação?
                        \n\n Os itens que já foram liberados até aqui não serão perdidos.`,
          hasImage: true,
          textButtonConfirm: "Não",
          textButtonCancel: "Sim"
        },
      });
      dialogRef.afterClosed().subscribe({
        next: (result) => {
          if (!result.confirm)
            this.matDialogRef.close({ checkMedicine: false });
          else {
            return;
          }
        },
        error: (error) => {
          console.log(error);
        }
      });
    }
    else
      this.matDialogRef.close({ checkMedicine: false });
  }
  
  nonDispensationAllModalComponent(solution: PrescriptionSolutionStruct) {
    if (this.isLoading)
      return;
    const dialogRef = this.dialog.open(PrescriptionSolutionNonDispensationAllModalComponent, {
      data: {
        solution: solution.listSolutionMedicine,
        patientName: this.episode.patientName,
        idPrescriptionSolution: solution.prescriptionSolution.idPrescriptionSolution,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if(result && result.notDispensed)
          this.matDialogRef.close({ notDispensedAll: true });
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  openPrescriptionSolutionModal(prescription: PrescriptionSolutionMedicineStruct) {
    const dialogRef = this.dialog.open(ReleasePrescriptionSolutionModalComponent, {
      data: {
        prescription: prescription,
        listLocation: this.listLocation,
        episode: this.data.episode,
        idPresentation: this.solution.prescriptionSolution.idPresentation,
        patientHasAllergy: this.solution.listSolutionMedicine.some(x => x.patientHasAllergy),
        presentationName: this.solution.presentationName,
        dilutionName: this.solution.dilutionName,
        administrationTypeName: this.solution.administrationTypeName,
        listDoseToAdministered: this.data.listDoseToAdministered,
        isObservation: this.isObservation,
        idSector: this.idSector,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result.liberate && !result.nonDispensation && result.liberatePrescriptionRequest != null) {
          this.listLiberatePrescription.push(result.liberatePrescriptionRequest);
          this.solution.listSolutionMedicine.forEach(x => {
            if (x.prescriptionSolutionMedicine.idPrescriptionSolutionMedicine == prescription.prescriptionSolutionMedicine.idPrescriptionSolutionMedicine) {
              x.prescriptionSolutionMedicine.idPrescriptionStatus = this.statusLiberatePrescriptionEnum;
              x.idLocation = result.liberatePrescriptionRequest.idLocation;
              x.quantityReleased = result.liberatePrescriptionRequest.quantity;
              x.idPresentationType = result.liberatePrescriptionRequest.idPresentationType;
              x.amountRemaining = result.liberatePrescriptionRequest.amountRemaining;
            }
          });

          this.cdr.detectChanges();
        }
        else if (result.nonDispensation) {
          this.listPrescriptionNonDispensationRequest.push(result.nonDispensationRequest);
          this.solution.listSolutionMedicine.forEach(x => {
            if (x.prescriptionSolutionMedicine.idPrescriptionSolutionMedicine == prescription.prescriptionSolutionMedicine.idPrescriptionSolutionMedicine)
              x.prescriptionSolutionMedicine.idPrescriptionStatus = this.statusNotDispensationPrescriptionEnum;
          });

          this.cdr.detectChanges();
        }
        else
          return;

        let listPrescriptionNoCompleteds = this.solution.listSolutionMedicine.filter(x => x.prescriptionSolutionMedicine.idPrescriptionStatus === null 
                                                                                    || x.prescriptionSolutionMedicine.idPrescriptionStatus === this.statusOpenPrescriptionEnum 
                                                                                    || x.prescriptionSolutionMedicine.idPrescriptionStatus === undefined);

        if (listPrescriptionNoCompleteds.length == 0 && !this.solution.listSolutionMedicine.every(x => x.prescriptionSolutionMedicine.idPrescriptionStatus === this.statusNotDispensationPrescriptionEnum)) {
          this.validated = true;
          this.nonDispenseAll = false;
        }
        else if ((this.solution.listSolutionMedicine.some(x => x.prescriptionSolutionMedicine.idPrescriptionStatus === this.statusLiberatePrescriptionEnum 
                                                    || x.prescriptionSolutionMedicine.idPrescriptionStatus === this.statusNotDispensationPrescriptionEnum)) 
                || (this.solution.listSolutionMedicine.every(x => x.prescriptionSolutionMedicine.idPrescriptionStatus === this.statusNotDispensationPrescriptionEnum))) {
          this.nonDispenseAll = false;
          this.validated = false;
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  openAdditionalItemsModal() {
    if (this.isLoading)
      return;
    const dialogRef = this.dialog.open(AdditionalItemModalComponent, {
      data: {
        listAdditionalItemsForRequest: this.listAdditionalItemsForRequest,
        listAdditionalMedicinesForRequest: this.listAdditionalMedicinesForRequest,
        listIdKit: this.data.solution?.listSelectedIdKit,
        isObservation: this.isObservation,
        idSector: this.idSector,
      },
      panelClass: 'prescription-additional-itens',
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result && result.listAdditionalItemsForRequest) {
          this.listAdditionalItemsForRequest = result.listAdditionalItemsForRequest
        }
        if (result && result.listAdditionalMedicinesForRequest) {
          this.listAdditionalMedicinesForRequest = result.listAdditionalMedicinesForRequest
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }
}